import 'react';
import { BsGeo } from '@react-icons/all-files/bs/BsGeo';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { AnchorTarget as AnchorTarget$1 } from './AnchorTarget.js';
import { AnchorTargetInspector } from './AnchorTarget.Inspector.js';
import { jsx } from '@emotion/react';

var AnchorTarget = decorateComponent(AnchorTarget$1, 'block', {
  id: 'anchorTarget',
  label: '앵커 타겟',
  defaultProps: {},
  allowedChildren: [],
  disallowedAncestors: ['a', 'coupon', 'tab', 'carousel', 'accordion'],
  renderIcon: function renderIcon() {
    return jsx(BsGeo, null);
  },
  renderTitle: function renderTitle(_ref) {
    var targetId = _ref.targetId;
    return "\uC575\uCEE4 \uD0C0\uAC9F #".concat(targetId !== null && targetId !== void 0 ? targetId : '');
  },
  renderInspector: AnchorTargetInspector
});

export { AnchorTarget as default };
//# sourceMappingURL=index.js.map
